import { AlmaOrb } from './AlmaOrb';

interface AuthCardProps {
  title: string;
  subtitle?: string;
  children: React.ReactNode;
}

/**
 * Shared shell for auth pages: centered rounded card with a marine gradient
 * header band holding the Alma orb.
 */
export function AuthCard({ title, subtitle, children }: AuthCardProps) {
  return (
    <div className="min-h-screen flex items-center justify-center py-12 px-4 sm:px-6 lg:px-8">
      <div className="max-w-md w-full rounded-3xl overflow-hidden shadow-warm bg-[var(--surface)] border border-[var(--card-border)] animate-fade-in-up">
        <div className="bg-gradient-to-br from-[var(--marine-600)] to-[var(--marine-400)] px-8 pt-10 pb-8 flex flex-col items-center text-center">
          <AlmaOrb size="lg" animated />
          <h1 className="mt-5 text-2xl font-display font-semibold text-white">{title}</h1>
          {subtitle && <p className="mt-1 text-white/80">{subtitle}</p>}
        </div>
        <div className="px-6 sm:px-8 py-8">{children}</div>
      </div>
    </div>
  );
}
